import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { makeStyles } from "tss-react/mui-compat"
import Autocomplete from "components/Autocomplete"
import { api } from "lib/api"
import { Tag } from "lib/types"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { useDebouncedCallback } from "use-debounce"

const useStyles = makeStyles()(
  (theme) => ({
    box: {
      display: "flex",
      flexDirection: "column",
      marginTop: theme.spacing(1),
    },
    autocompleteRoot: {
      ["& .makeStyles-root-9"]: {
        marginBottom: 0,
      },
    },
  }),
)

interface ITagsAutocomplete {
  action: (payload: any) => void
  state: any
}

const TagsAutocomplete = (props: ITagsAutocomplete) => {
  const { action, state } = props

  const [loadingTags, setLoadingTags] = useState(false)
  const [tagTerm, setTagTerm] = useState("")
  const [tags, setTags] = useState<Array<string>>([])

  const { query } = useRouter()

  const debouncedTagSearch = useDebouncedCallback(async () => {
    setLoadingTags(true)
    const searchFn = !!query.convention_id
      ? api.conventionTags({ req: undefined }, query.convention_id as string, tagTerm)
      : api.searchTags({ req: undefined }, tagTerm)
    const { data: tags } = await searchFn
    const results = tags.map((tag: Tag) => tag.attributes.name)
    setTags(results)
    setLoadingTags(false)
  }, 250)

  useEffect(() => {
    debouncedTagSearch.callback()
  }, [tagTerm])

  const { classes } = useStyles()

  return (
    <Box className={classes.box}>
      <Typography variant="body1" color="textSecondary">
        Tags
      </Typography>
      <Autocomplete
        multiple
        loading={loadingTags}
        options={tags}
        classes={{
          root: classes.autocompleteRoot,
        }}
        value={state.tags}
        onChange={(_, data) =>
          action({
            tags: data,
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Search Tags"
            margin="normal"
            InputProps={{ ...params.InputProps }}
            onChange={(e) => setTagTerm(e.target.value)}
          />
        )}
      />
    </Box>
  )
}

export default TagsAutocomplete
